import React from 'react';

const Home = () => (
  <>
    <section className="hero">
      <h1>Hestia Ledger</h1>
      <p>Your simple, secure way to manage what matters.</p>
      <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
    </section>
    <section className="features">
      <div className="feature">
        <h2>Simple</h2>
        <p>No clutter—just the tools you need.</p>
      </div>
      <div className="feature">
        <h2>Yours</h2>
        <p>Own your ledger, no middlemen.</p>
      </div>
    </section>
    <section className="cta">
      <h2>Ready to Take Control?</h2>
      <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
    </section>
  </>
);

export default Home;